import React from 'react'

const BackgroundElementImg = ({
    cssClassImg,
    alt,
    src,
    srcFallback,
    imgStyles = {},
    fallbackInUse,
    setFallback
}) => (
    <img 
        src={src} 
        className={cssClassImg}
        alt={alt} 
        style={imgStyles}
        onError={({ currentTarget }) => {
            if(fallbackInUse) {
                currentTarget.onerror = null; 
                currentTarget.src = '';
            } else {
                setFallback(true)
                currentTarget.onerror = null; 
                currentTarget.src = srcFallback;
            }
        }}
    />
)

export default BackgroundElementImg